<template>
  <div class="icp-root">
    <div class="index-c-pop-root"> <!-- v-bind:class="[popType === 0 ? 'c-height1' : 'c-height2']" -->
      <div v-show="popType === 0"><!-- class="c-height1" -->
        <div class="index-c-pop-line flex-row ct" v-for="(item,pIndex) in priceList" :key="pIndex" v-on:click="onPriceItemClick(pIndex)"
             v-bind:class="[priceIndex === pIndex ? 'index-c-pop-line-select' : 'index-c-pop-line-unselect']">
          <span>{{item.text}}</span>
          <div class="flex"></div>
          <img v-show="priceIndex === pIndex" src="../images/ic_index_gou.png">
        </div>
      </div>
      <div v-show="popType === 1" class="c-height2">
        <div class="index-c-pop-line flex-row ct" v-for="(item,aIndex) in addressList" :key="aIndex" v-on:click="onAddressItemClick(aIndex)"
             v-bind:class="[addressIndex === aIndex ? 'index-c-pop-line-select' : 'index-c-pop-line-unselect']">
          <span>{{item.area}}</span>
          <div class="flex"></div>
          <img v-show="addressIndex === aIndex" src="../images/ic_index_gou.png">
        </div>
      </div>
    </div>
    <div class="index-c-pop-other" v-on:click="onPopClick"></div>
  </div>
</template>

<script>
export default {
  name: 'index-complex-pop',
  props: {
    popType: {
      type: Number,
      default: 0 // 0表示价格；1表示地区
    },
    priceSelectIndex: {
      type: Number,
      default: 0
    },
    addressSelectIndex: {
      type: Number,
      default: 0
    },
    scrollY: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      priceIndex: 0,
      addressIndex: 0,
      priceList: [{text: '价格从低到高', value: 4}, {text: '价格从高到低', value: 5}, {text: '电议', value: 6}],
      addressList: [
        {area: '全部', value: -1},
        {area: '北京市', value: 110000},
        {area: '天津市', value: 120000},
        {area: '河北省', value: 130000},
        {area: '山西省', value: 140000},
        {area: '内蒙古自治区', value: 150000},
        {area: '辽宁省', value: 210000},
        {area: '吉林省', value: 220000},
        {area: '黑龙江省', value: 230000},
        {area: '上海市', value: 310000},
        {area: '江苏省', value: 320000},
        {area: '浙江省', value: 330000},
        {area: '安徽省', value: 340000},
        {area: '福建省', value: 350000},
        {area: '江西省', value: 360000},
        {area: '山东省', value: 370000},
        {area: '河南省', value: 410000},
        {area: '湖北省', value: 420000},
        {area: '湖南省', value: 430000},
        {area: '广东省', value: 440000},
        {area: '广西壮族自治区', value: 450000},
        {area: '海南省', value: 460000},
        {area: '重庆市', value: 500000},
        {area: '四川省', value: 510000},
        {area: '贵州省', value: 520000},
        {area: '云南省', value: 530000},
        {area: '西藏自治区', value: 540000},
        {area: '陕西省', value: 610000},
        {area: '甘肃省', value: 620000},
        {area: '青海省', value: 630000},
        {area: '宁夏回族自治区', value: 640000},
        {area: '新疆维吾尔自治区', value: 650000},
        {area: '台湾省', value: 710000},
        {area: '香港特别行政区', value: 810000},
        {area: '澳门特别行政区', value: 820000}
      ]
    }
  },
  methods: {
    onPriceItemClick: function (index) {
      this.priceIndex = index
      const priceItem = this.priceList[index]
      this.$emit('onIndexCPopClick', this.popType, index, priceItem.value + '')
    },
    onAddressItemClick: function (index) {
      this.addressIndex = index
      const addressItem = this.addressList[index]
      this.$emit('onIndexCPopClick', this.popType, index, addressItem.area)
    },
    onPopClick: function () {
      this.$emit('onIndexCPopClick', this.popType, -1, '')
    }
  },
  watch: {
    priceSelectIndex: function (newVal) {
      this.priceIndex = newVal
    },
    addressSelectIndex: function (newVal) {
      this.addressIndex = newVal
    }
  }
}
</script>

<style scoped>
  * { touch-action: pan-y; }
  .flex-row {
    display: flex;
    flex-direction: row;
  }
  .ct {
    align-items: center;
    justify-content: center;
  }
  .flex {
    flex: 1;
  }
  .icp-root {
    width: 100%;
    height: 100%;
    position: fixed;
    z-index: 600;
    background: rgba(0, 0, 0, 0.6);
  }
  .index-c-pop-root {
    width: 100%;
    position: relative;
    background: white;
  }
  .c-height1 {
    height: calc(40px * 2);
    overflow-y: scroll;
  }
  .c-height2 {
    height: 300px;
    overflow-y: scroll;
  }
  .index-c-pop-line {
    width: 100%;
    height: 40px;
    padding-left: 13px;
    font-size: 14px;
    border-bottom-style: solid;
    border-bottom-width: 1px;
    border-bottom-color: #f2f2f2;
  }
  .index-c-pop-line-unselect {
    color: #808080;
  }
  .index-c-pop-line-select {
    color: #C41335;
  }
  .index-c-pop-line img {
    width: 11px;
    height: 8px;
    margin-right: 13px;
  }
  .index-c-pop-other {
    width: 100%;
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/view/shopping/goods/index-complex-pop.vue